export default {
  items: [
    {
      _name: 'CSidebarNav',
      _children: [
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản lý kho',
          icon: 'cib-dropbox',
          items: [
            {
              name: 'Phiếu nhập/xuất',
              to: '/stock-management/list.html'
            },
            {
              name: 'Kiểm tra tồn kho',
              to: '/stock-management/checkInOut.html'
            },
            {
              name: 'Tra cứu thông tin',
              to: '/stock-management/productLotSerial.html'
            },
                        {
              name: 'Tra cứu thông tin luân chuyển hàng hóa',
              to: '/stock-management/check-flow.html'
            },
            {
              name: 'Danh sách kho',
              to: '/warehouse-management/list.html'
            },
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản lý sản phẩm',
          icon: 'cil-tags',
          items: [
            {
              name: 'Danh sách sản phẩm',
              to: '/product-management/list.html'
            },
            {
              name: 'Danh mục sản phẩm',
              to: '/category-management/list.html'
            },
            {
              name: 'Danh mục ĐVT',
              to: '/uom-management/list.html'
            },
          ]
        },
        {
          _name: 'CSidebarNavItem',
          name: 'Danh mục khách hàng',
          icon: 'cib-staticman',
          to: '/customer-management/list.html'
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản trị',
          icon: 'cil-settings',
          items: [
            {
              name: 'Quản lý đơn vị',
              to: '/administrator/organization.html',
            },  
            {
              name: 'Quản lý tiến trình',
              to: '/administrator/thread.html',
            },  
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Tài chính && Kế toán',
          icon: 'cil-money',
          items: [
            {
              name: 'Hóa đơn',
              to: '/accounting-management/invoice.html'
            },
          ]
        },
        {
          _name: 'CSidebarNavDropdown',
          name: 'Quản lý tài khoản',
          icon: 'cil-people',
          items: [
            {
              name: 'Danh sách tài khoản',
              to: '/user-management/managed-users.html',
            },
            {
              name: 'Đổi mật khẩu',
              // icon: 'cil-user',
              to: '/user/reset-password.html'
            },
          ]
        }
      ]
    },
  ]
}
